// biome-ignore lint/style/noRestrictedImports: StyledEngineProvider has no deep path export in MUI v9
import { StyledEngineProvider } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import '@emotion/react';
import '@emotion/styled';
import 'assets/styles/index.scss';

import type { Properties } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import AuthBootstrapGate from './components/AuthBootstrapGate';
import { persistor, store } from './redux/store';

const POSTHOG_ENABLED = false;

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'always',
  sanitize_properties: (properties: Properties) => {
    return {
      ...properties,
      filterOutEvent: import.meta.env.VITE_PUBLIC_POSTHOG_FILTER_OUT_EVENTS,
    };
  },
} as const;

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const appContent = (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <StyledEngineProvider injectFirst>
        <BrowserRouter>
          <AuthBootstrapGate>
            <App />
          </AuthBootstrapGate>
        </BrowserRouter>
      </StyledEngineProvider>
    </PersistGate>
  </Provider>
);

const root = createRoot(container);
root.render(
  <React.StrictMode>
    {POSTHOG_ENABLED ? (
      <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
        {appContent}
      </PostHogProvider>
    ) : (
      appContent
    )}
  </React.StrictMode>
);
